module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tickets-ativos",
    class: {
      'nodata': !_vm.remocoes || _vm.remocoes.length === 0
    }
  }, [_c('h3', [_vm._v("Tickets Ativos")]), _vm._v(" "), _vm._l((_vm.remocoes), function(remocao) {
    return _c('div', {
      key: remocao.id,
      staticClass: "item"
    }, [_c('h4', [_vm._v(_vm._s(remocao.categoria ? remocao.categoria.traducao.es : 'Em preenchimento'))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(remocao.nomeVeiculo ? remocao.nomeVeiculo : 'Em preenchimento'))]), _vm._v(" "), _c('small', [_c('b', [_vm._v("De: ")]), _vm._v(_vm._s(remocao.enderecoRecolhimento ? remocao.enderecoRecolhimento : 'Aguardando definição no atendimento'))]), _vm._v(" "), _c('small', [_c('b', [_vm._v("Para: ")]), _vm._v(_vm._s(remocao.patioDestino ? remocao.patioDestino.nome : 'Aguardando definição no atendimento'))]), _vm._v(" "), (remocao.reboquista) ? _c('small', [_vm._v("R: " + _vm._s(remocao.reboquista.nome))]) : _vm._e(), _vm._v(" "), (remocao.dataInicio) ? _c('small', [_vm._v("Solicitado em " + _vm._s(_vm._f("formatDate")(remocao.dataInicio.date, 'DD/MM HH:mm')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((remocao.etapas), function(etapa) {
      return _c('li', {
        class: {
          'ativo': etapa.active, 'completed': etapa.completed
        }
      }, [_vm._v(_vm._s(etapa.descricao) + "\n      ")])
    }), 0), _vm._v(" "), _c('context-menu-remocao-ticket', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (remocao.etapa < 4),
        expression: "remocao.etapa < 4"
      }],
      attrs: {
        "remocao": remocao
      }
    })], 1)
  }), _vm._v(" "), (!_vm.remocoes || _vm.remocoes.length === 0) ? _c('div', {
    staticClass: "wrapper"
  }, [_vm._v("\n    Nenhum ticket ativo. Inicie um atendimento.\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a522ecb4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/TicketsAtivos.vue
// module id = 1821
// module chunks = 17